export default {
  props: {
    maxSize: {
      type: Number,
      default: 25, // Size of file in MB
    },
    xlsMaxSize: {
      type: Number,
      default: 5,
    },
  },
  data: () => ({
    errors: [],
  }),
  methods: {
    validate(file) {
      if (!file) { return false; }
      const size = file.size / (1024 * 1024);
      const fileExtension = file.name.split('.')[1];
      if (size > this.maxSize && !fileExtension.startsWith('xls')) {
        this.errors.push(`The file "${file.name}" is too big, please select a file up to ${this.maxSize}MB.`);
      } else if (size > this.xlsMaxSize && fileExtension.startsWith('xls')) {
        this.errors.push(`The file "${file.name}" is too big. XLS file limit is ${this.xlsMaxSize}MB.`);
      } else if (size === 0) {
        this.errors.push(`The file "${file.name}" is empty, please select a valid file.`);
      }

      return this.errors.length === 0;
    },
    clearErrors() {
      this.errors = [];
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/utils/upload/uploadValidatorMixin.js